import {SidebarModel, AccessesModel} from 'domain/usecases';
import {BeneficiaryModel} from 'domain/usecases/others/selection-flow/beneficiary-v3';
import {AccountData, LoggedUserModel} from './types';

const ACCOUNT_STORAGE_KEY = 'account';

const DEFAULT_ACCOUNT_DATA: AccountData = {
	beneficiary: {} as BeneficiaryModel,
	sidebar: {} as SidebarModel,
	accesses: {} as AccessesModel,
	logged_user: {} as LoggedUserModel,
	accessed_user: {} as LoggedUserModel,
	planBeneficiaries: [] as BeneficiaryModel[],
	beneficiariesLength: 0,
};

export {ACCOUNT_STORAGE_KEY, DEFAULT_ACCOUNT_DATA};
